'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _Avatar = require('material-ui/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _styles = require('material-ui/styles');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  row: {
    display: 'flex',
    justifyContent: 'center'
  },
  avatar: {
    margin: 10,
    textDecoration: "none" // maxWidth: "100%",
    // height: "auto",

  },
  smallAvatar: {
    width: 40,
    height: 40
  },
  bigAvatar: {
    width: 120,
    height: 120
  },
  editable: {
    cursor: 'pointer'
  }
};
var UserAvatar = exports.UserAvatar = (_temp = _class = function (_Component) {
  _inherits(UserAvatar, _Component);

  function UserAvatar() {
    _classCallCheck(this, UserAvatar);

    return _possibleConstructorReturn(this, (UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).apply(this, arguments));
  }

  _createClass(UserAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          classes = _props.classes,
          size = _props.size,
          editable = _props.editable,
          other = _objectWithoutProperties(_props, ['user', 'classes', 'size', 'editable']);

      if (!user) {
        return null;
      }

      var assetsBaseUrl = this.context.assetsBaseUrl;
      var id = user.id,
          image = user.image,
          username = user.username,
          fullname = user.fullname,
          firstname = user.firstname,
          lastname = user.lastname; // const name = [firstname, lastname].filter(n => n).reduce((prev, next) => [prev, " ", next]) || username;

      var name = fullname || [firstname, lastname].filter(function (n) {
        return n;
      }).join(" ") || username;
      var classNames = [classes.avatar];
      var url = void 0;

      if (image) {
        // url = `/images/avatar/${image}`;
        // url = `/images/resized/thumb/uploads/${image}`;
        url = (assetsBaseUrl !== undefined ? assetsBaseUrl : "/") + 'images/resized/thumb/' + image;
      }

      switch (size) {
        case 'small':
          classNames.push(classes.smallAvatar);
          break;

        case 'big':
          classNames.push(classes.bigAvatar);
          break;
      }

      if (editable) {
        classNames.push(classes.editable);
      }

      return _react2.default.createElement(_Avatar2.default, _extends({
        alt: name,
        src: url || undefined,
        className: classNames.join(" ")
      }, other), url ? "" : name && name.substr(0, 1).toLocaleUpperCase() || "A");
    }
  }]);

  return UserAvatar;
}(_react.Component), _class.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  size: _propTypes2.default.string.isRequired,
  editable: _propTypes2.default.bool.isRequired
}, _class.defaultProps = {
  size: "normal",
  // size: "big",
  editable: false
}, _class.contextType = _context2.default, _temp);
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(UserAvatar, props);
});